import { cn } from '@helpers/cn';

import { EnvironmentBadge } from '..';
import { TProps } from '../types/TProps';

export const EnvironmentBadgeDemo = ({ className, ...props }: TProps) => (
  <EnvironmentBadge {...props} className={cn('env-badge--demo', className)} />
);
